module.exports = __webpack_public_path__ + "static/media/material-denim.e795da9c.svg";